export default "__VITE_ASSET__CS1aR47___"